import React, { useState } from 'react';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const currentPath = window.location.pathname;
  const posStoreName = localStorage.getItem("LoaiCH") === "0" ? "bonpas" : "dongtien";

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("MaPB");
    localStorage.removeItem("IDCH");
    localStorage.removeItem("isAdmin");
    window.location.href = "/logintt";
  };

  const menuItems = [
    { path: '/order/dongtien', label: 'POS' },
    { path: `/pos-trung-thu/${posStoreName}`, label: 'POS Trung Thu' },
    { path: `/tktt`, label: 'Thống kê Trung Thu' },
    { path: '/nhaphangtt', label: 'Giao nhận Trung Thu' }
  ];

  return (
    <>
      <nav style={{
        background: 'linear-gradient(135deg, #e74c3c 0%, #ff6b35 50%, #f39c12 100%)',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: 0
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '1rem 2rem',
          position: 'relative'
        }}>
          {/* Mobile Menu Button */}
          <button
            onClick={handleDrawerToggle}
            style={{
              display: 'none',
              background: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
            className="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            ☰
          </button>

          {/* Desktop Menu */}
          <ul style={{
            display: 'flex',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            gap: '2rem'
          }} className="navbar-menu">
            {menuItems.map((item) => (
              <li key={item.path}>
                <a
                  href={item.path}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    fontWeight: currentPath === item.path ? '600' : '500',
                    padding: '0.5rem 1rem',
                    borderRadius: '8px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    backgroundColor: currentPath === item.path ? 'rgba(255, 255, 255, 0.3)' : 'transparent',
                    borderColor: currentPath === item.path ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.3)',
                    transition: 'all 0.3s ease',
                    display: 'inline-block'
                  }}
                  onMouseEnter={(e) => {
                    if (currentPath !== item.path) {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.borderColor = 'rgba(255, 255, 255, 0.6)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (currentPath !== item.path) {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                    }
                  }}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop Logout Button */}
          <button
            onClick={handleLogout}
            className="logout-button"
            style={{
              position: 'absolute',
              right: '2rem',
              borderRadius: '20px',
              fontWeight: 600,
              padding: '0.5rem 1rem',
              backgroundColor: '#d32f2f',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              transition: 'all 0.3s ease',
              fontSize: '0.875rem'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 10px rgba(0,0,0,0.25)';
              e.target.style.backgroundColor = '#c62828';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
              e.target.style.backgroundColor = '#d32f2f';
            }}
          >
            <span style={{ fontSize: '1.2rem' }}>⎋</span>
            Đăng xuất
          </button>
        </div>
      </nav>

      {/* Mobile Drawer Overlay */}
      {mobileOpen && (
        <div
          onClick={handleDrawerToggle}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1100,
            animation: 'fadeIn 0.3s ease'
          }}
        />
      )}

      {/* Mobile Drawer */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: mobileOpen ? 0 : '-280px',
          width: '280px',
          height: '100%',
          background: 'linear-gradient(135deg, #e74c3c 0%, #ff6b35 50%, #f39c12 100%)',
          padding: '20px',
          zIndex: 1200,
          transition: 'left 0.3s ease',
          overflowY: 'auto'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <button
            onClick={handleDrawerToggle}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '1.8rem',
              cursor: 'pointer',
              padding: '0.5rem',
              lineHeight: 1
            }}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {menuItems.map((item) => (
            <li key={item.path} style={{ marginBottom: '15px' }}>
              <a
                href={item.path}
                onClick={() => setMobileOpen(false)}
                style={{
                  display: 'block',
                  color: 'white',
                  textDecoration: 'none',
                  fontWeight: currentPath === item.path ? '600' : '500',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  backgroundColor: currentPath === item.path ? 'rgba(255, 255, 255, 0.3)' : 'transparent',
                  borderColor: currentPath === item.path ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.3)',
                  transition: 'all 0.3s ease'
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: '30px' }}>
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              borderRadius: '20px',
              fontWeight: 600,
              padding: '12px',
              backgroundColor: '#d32f2f',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              fontSize: '1rem'
            }}
          >
            <span style={{ fontSize: '1.2rem' }}>⎋</span>
            Đăng xuất
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @media (max-width: 768px) {
          .navbar-menu {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
            position: absolute;
            left: 1rem;
          }
          .logout-button {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;
